import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { DestinationSelect, Title, ListItem, Item } from './DestinationFilterStyle';
import { trackMiceClick } from 'UtilityComponents/miceUtils';

const DestinationFilter = ({ searchResults, isMobile }) => {
	const searchFilterData = useSelector((state) => state.mice.searchFilterData);
	const hotelSearchData = useSelector((state) => state.mice.hotelSearchData);
	const { cities = [] } = hotelSearchData || {};

	const handleSelectDestination = (item) => () => {
		trackMiceClick(`${item}_clicked`);
		searchResults({ city: item });
	};

	return (
		<DestinationSelect>
			{!isMobile && <Title f_weight='700' color='#000' right_P='8'>Select Destinations</Title>}
			{cities && cities.length > 0 &&
				<ListItem>
					{cities.map((item) => (
						<Item
							key={item.value}
							className={item.label === searchFilterData.city ? 'active' : ''}
							onClick={handleSelectDestination(item.value)}>
							{item.label}
						</Item>
					))}
				</ListItem>}
		</DestinationSelect>
	);
};

export default memo(DestinationFilter);
